export default "__VITE_ASSET__C_6SMqY5__"